module.exports = __webpack_public_path__ + "static/media/starLogo.47cf491d.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/starLogo.png
// module id = 734
// module chunks = 0